import { AppRouteProps } from "@harea/component";
import React from "react";
import { Outlet } from "react-router-dom";
import { ProjectCalendarRoutes } from "views/calendar/CalendarRoutes";
import { ProjectDayOffRoutes } from "views/dayoff/ProjectDayOffRoutes";

const ProjectContainer = React.lazy(() => import("./containers/ProjectContainer"));

// const PresenceContainer = React.lazy(() => import("./containers/PresenceContainer"));

export const ProjectRoutes: Array<AppRouteProps> = [
    // {
        // path: "project",
        // title: "BSMRH.Project",
        // element: <ProjectContainer id="ProjectContainer" view="timeGridWeek" />,
        // roles: ["TIMEOFF"],
        // hideBreadcrumb: true,
        // children: [
        //     ...ProjectCalendarRoutes,
        // ]
    // },
    // {
    //     path: "project",
    //     title: "BSMRH.Project",
    //     roles: ["TIMEOFF"],
    //     hideBreadcrumb: true,
    //     children: [
    //         ...ProjectDayOffRoutes,
    //     ]
    // }
    ...ProjectDayOffRoutes,
];
